<template>
	<div>
		<commonHeader />
		<div v-if="nowWidth > 784">
			<div class="team_1">
				<v-img src="/image/team_1.png" class="px-pc">
					<div class="about_1_text">
						About Team
					</div>
					<v-layout>
						<v-layout class="tab-css-2">
							<v-flex v-for="(tab, i) in $store.state.tabList" :key="i" class="pr-8" style="flex: 1; max-width: 20%;">
								<v-flex xs12>
									<v-divider dark class="main-hr-1 mb-4"></v-divider>
								</v-flex>
								<div>
									<div class="number mr-2">0{{ i + 1 }}</div>
									<div class="Title" @click="titleGoto(tab.link)">
										{{ tab.title }}
									</div>
								</div>
							</v-flex>
						</v-layout>
					</v-layout>
				</v-img>
			</div>
			<div class="px-pc team_layout">
				<v-layout class="team_text_1" align-center wrap>
					<hr class="line" />
					<div class="text">CEO</div>
					<v-layout style="width:100%">
						<v-hover v-slot="{ hover }">
							<v-card>
								<v-img src="/image/team19.png">
									<div v-if="hover" class="team-overlay v-card--reveal">
										과학기술인공제회<br />
										한양증권<br />
										대교홀딩스<br />
										한양대 경영학 석사<br />
										한양대 회계학 학사
									</div>
								</v-img>
							</v-card>
						</v-hover>
					</v-layout>
					<div class="team_subtext">
						홍순조 대표이사
					</div>
				</v-layout>
				<v-layout class="team_text_1" align-center wrap>
					<hr class="line" />
					<div class="text">투자1본부</div>
					<v-flex xs12>
						<v-layout style="width: min-content;">
							<v-layout wrap class="layout-setting">
								<v-hover v-slot="{ hover }">
									<v-card>
										<v-img src="/image/team2.png">
											<div v-if="hover" class="team-overlay v-card--reveal">
												한화인베스트먼트<br />
												우리프라이빗에퀴티<br />
												삼일회계법인<br />
												서울대학교 경영학 학사
											</div>
										</v-img>
									</v-card>
								</v-hover>
								<div>
									<div class="team_subtext">
										안욱 투자1본부 본부장
									</div>
								</div>
							</v-layout>
							<v-layout wrap class="layout-setting ml-12 pl-6">
								<v-hover v-slot="{ hover }">
									<v-card>
										<v-img src="/image/team12.png">
											<div v-if="hover" class="team-overlay v-card--reveal">
												<br />
												시그나이트<br />신한캐피탈<br />중앙대학교 경영학 학사
											</div>
										</v-img>
									</v-card>
								</v-hover>
								<div>
									<div class="team_subtext">
										박건민 투자1본부 팀장
									</div>
								</div>
							</v-layout>
						</v-layout>
					</v-flex>
				</v-layout>
				<v-layout class="team_text_1" align-center wrap>
					<hr class="line" />
					<div class="text">투자2본부</div>
					<v-flex xs12>
						<v-layout style="width: min-content;">
							<v-layout style="width: min-content;">
								<v-layout wrap class="layout-setting">
									<v-hover v-slot="{ hover }">
										<v-card>
											<v-img src="/image/team16.png">
												<div v-if="hover" class="team-overlay v-card--reveal">
													라이트하우스컴바인인베스트<br />송현인베스트먼트<br />에트리홀딩스<br />한국항공우주연구원<br />SK네트웍스<br />포항공대
													기술경영 석사<br />숭실대 정보통신전자공학 학사
												</div>
											</v-img>
										</v-card>
									</v-hover>
									<v-flex xs12>
										<div class="team_subtext">
											김일태 투자2본부 본부장
										</div>
									</v-flex>
								</v-layout>
							</v-layout>
							<v-layout wrap class="layout-setting ml-12 pl-6">
								<v-hover v-slot="{ hover }">
									<v-card>
										<v-img src="/image/team18.png">
											<div v-if="hover" class="team-overlay v-card--reveal">
												롯데케미칼<br />
												KAIST 생명화학공학 석사<br />
												성균관대학교 화학공학 학사<br />
											</div>
										</v-img>
									</v-card>
								</v-hover>
								<v-flex xs12>
									<div class="team_subtext">
										이종욱 투자2본부 부장
									</div>
								</v-flex>
							</v-layout>
							<v-layout wrap class="layout-setting ml-12 pl-6">
								<v-hover v-slot="{ hover }">
									<v-card>
										<v-img src="/image/team8.png">
											<div v-if="hover" class="team-overlay v-card--reveal">
												토스증권<br />
												신한금융투자<br />
												KAIST PMBA 석사<br />
												성균관대학교 경제학 학사
											</div>
										</v-img>
									</v-card>
								</v-hover>
								<v-flex xs12>
									<div class="team_subtext">
										김규리 투자2본부 팀장
									</div>
								</v-flex>
							</v-layout>
						</v-layout>
					</v-flex>
				</v-layout>
				<v-layout class="team_text_1" align-center wrap>
					<hr class="line" />
					<div class="text">PE팀</div>
					<v-layout style="width:100%">
						<v-hover v-slot="{ hover }">
							<v-card>
								<v-img src="/image/team9.png">
									<div v-if="hover" class="team-overlay v-card--reveal">
										삼호그린인베스트먼트<br />
										딜로이트안진회계법인<br />
										한국공인회계사 (KICPA)<br />
										연세대학교 경제학 학사<br />
									</div>
								</v-img>
							</v-card>
						</v-hover>
					</v-layout>
					<div class="team_subtext">
						이형주 PE팀 팀장
					</div>
				</v-layout>
				<v-layout class="team_text_1 team_last" align-center wrap>
					<hr class="line" />
					<div class="text">경영관리본부</div>
					<v-flex xs12>
						<v-layout style="width: min-content;">
							<v-layout wrap class="layout-setting">
								<v-hover v-slot="{ hover }">
									<v-card>
										<v-img src="/image/team15.png">
											<div v-if="hover" class="team-overlay v-card--reveal">
												과학기술인공제회<br />한양대학교 부동산융합대학원 석사<br />이화여자대학교 영어영문학·경영학 학사
											</div>
										</v-img>
									</v-card>
								</v-hover>
								<div>
									<div class="team_subtext">
										이현주 경영관리본부 본부장
									</div>
								</div>
							</v-layout>
							<!-- <v-layout wrap class="layout-setting ml-12 pl-6">
								<v-hover v-slot="{ hover }">
									<v-card>
										<v-img src="/image/team6.png">
											<div v-if="hover" class="team-overlay v-card--reveal">
												엠벤처투자<br />
												HB인베스트먼트<br />
												큐브벤처파트너스<br />
												대전대학교 산업심리학 학사
											</div>
										</v-img>
									</v-card>
								</v-hover>
								<v-flex xs12>
									<div class="team_subtext">
										권다영 경영관리본부 팀장
									</div>
								</v-flex>
							</v-layout> -->
							<v-layout wrap class="layout-setting ml-12 pl-6">
								<v-hover v-slot="{ hover }">
									<v-card>
										<v-img src="/image/team14.png">
											<div v-if="hover" class="team-overlay v-card--reveal">
												<br />
												송현인베스트먼트<br />
												대구대학교 금융보험학 학사
											</div>
										</v-img>
									</v-card>
								</v-hover>
								<v-flex xs12>
									<div class="team_subtext">
										홍성은 경영관리본부 팀장
									</div>
								</v-flex>
							</v-layout>
							<v-layout wrap class="layout-setting ml-12 pl-6">
								<v-hover v-slot="{ hover }">
									<v-card>
										<v-img src="/image/team13.png">
											<div v-if="hover" class="team-overlay v-card--reveal">
												<br />
												우신벤처투자<br />
												세종대학교 경영학 학사
											</div>
										</v-img>
									</v-card>
								</v-hover>
								<v-flex xs12>
									<div class="team_subtext">
										이윤하 경영관리본부 사원
									</div>
								</v-flex>
							</v-layout>
						</v-layout>
					</v-flex>
				</v-layout>
			</div>
			<div class="team_2">
				<v-img contain src="/image/team_2.png"></v-img>
			</div>
		</div>
		<div v-else>
			<div class="m_team_1">
				<v-img width="100%" src="/image/m_team_1.png" class="pl-6">
					<div class="m_about_1_text">
						About Team
					</div>
				</v-img>
			</div>
			<v-layout class="m_divider_1_layout mb-0">
				<hr class="m_divider_4" />
				<div class="m_team_text_1 ml-12 pl-5">CEO</div>
			</v-layout>
			<v-layout class="m_team_img_layout">
				<v-img max-width="481" width="100%" contain src="/image/m_team19.png"></v-img>
			</v-layout>
			<v-layout class="m_divider_1_layout mb-0">
				<hr class="m_divider_3" />
				<div class="m_team_text_1 mb-2">투자1본부</div>
			</v-layout>
			<v-layout class="m_team_img_layout">
				<v-img max-width="481" width="100%" contain src="/image/m_team2.png"></v-img>
			</v-layout>
			<v-layout class="m_team_img_layout mt-6">
				<v-img max-width="481" width="100%" contain src="/image/m_team12.png"></v-img>
			</v-layout>

			<v-layout class="m_divider_1_layout mb-0">
				<hr class="m_divider_3" />
				<div class="m_team_text_1 mb-2">투자2본부</div>
			</v-layout>
			<v-layout class="m_team_img_layout mt-6">
				<v-img max-width="481" width="100%" contain src="/image/m_team16.png"></v-img>
			</v-layout>
			<v-layout class="m_team_img_layout mt-6">
				<v-img max-width="481" width="100%" contain src="/image/m_team18.png"></v-img>
			</v-layout>
			<v-layout class="m_team_img_layout mt-6">
				<v-img max-width="481" width="100%" contain src="/image/m_team8.png"></v-img>
			</v-layout>
			<v-layout class="m_divider_1_layout mb-0">
				<hr class="m_divider_3" />
				<div class="m_team_text_1 mb-2">PE팀</div>
			</v-layout>
			<v-layout class="m_team_img_layout">
				<v-img max-width="481" width="100%" contain src="/image/m_team9.png"></v-img>
			</v-layout>
			<v-layout class="m_divider_1_layout mb-0">
				<hr class="m_divider_3" />
				<div class="m_team_text_1 mb-2">경영관리본부</div>
			</v-layout>
			<v-layout class="m_team_img_layout">
				<v-img max-width="481" width="100%" contain src="/image/m_team15.png"></v-img>
			</v-layout>
			<v-layout class="m_team_img_layout mt-6">
				<v-img max-width="481" width="100%" contain src="/image/m_team14.png"></v-img>
			</v-layout>
			<v-layout class="m_team_img_layout mt-6 m_last_img">
				<v-img max-width="481" width="100%" contain src="/image/m_team13.png"></v-img>
			</v-layout>
			<div>
				<v-img contain src="/image/m_team_2.png"></v-img>
			</div>
		</div>
		<commonFooter />
	</div>
</template>
<script>
import { commonHeader, commonFooter } from '@/components/index'
export default {
	components: {
		commonHeader,
		commonFooter,
	},
	data() {
		return {
			screenWidth: window.innerWidth,
		}
	},
	computed: {
		nowWidth() {
			window.addEventListener('resize', () => {
				this.screenWidth = window.innerWidth
			})
			return this.screenWidth
		},
	},
	methods: {
		titleGoto(link) {
			this.$router.push({ name: link })
		},
	},
}
</script>
